import { useShallow } from "zustand/react/shallow";
import {
  type CalendarTimeOff,
  useCalendarStore,
} from "../../store/useCalendarStore";

/** Opens the calendar drawer on a time off, to edit it. */
export function useOpenTimeOff() {
  const { setSelectedTimeOff, setLastSelectedDate } = useCalendarStore(
    useShallow((state) => ({
      setSelectedTimeOff: state.setSelectedTimeOff,
      setLastSelectedDate: state.setLastSelectedDate,
    })),
  );

  function openTimeOff(timeoff: CalendarTimeOff, date: string) {
    setLastSelectedDate(date);
    setSelectedTimeOff({
      id: timeoff.id,
      source: timeoff.source,
      seriesId: timeoff.seriesId,
    });
  }

  return openTimeOff;
}
